import { Connect } from '@carbon/pictograms-react';
import * as React from 'react';
export default {
  Connect,
  React
};